import React, { useEffect, useState } from "react";
import classNames from "classnames/bind";
import styles from './Switch.module.css'

const cx = classNames.bind(styles)
const Switch = ({ type = "normal", value, onChange, disable}) => {
  const [check, setCheck] = useState()
  useEffect(() => {
    setCheck(value)
  }, [value])
  const onChanges = (e) => {
    const value = e.target.checked
    onChange(value)
    setCheck(value)
  }

  return (
    <div>
      <label className={cx("switch", type, disable ? 'disable' : '')}>
        <input onChange={onChanges} value={true} checked={check} type="checkbox" disabled={disable}/>
        <span className={cx("slider", "round")}></span>
      </label>
    </div>
  );
};

export default Switch;
